import { useState } from 'react'
import { useHomeStore } from '../store'
import type { CoverageValues } from '../types'
import { VehicleCard, isHavarijniActive } from './VehicleCard'
import { CoverageModal } from './CoverageModal'
import { DeleteVehicleModal } from './DeleteVehicleModal'

interface Props {
  onReenqueue?: (id: number) => void
}

export function VehicleList({ onReenqueue }: Props) {
  const vehicles = useHomeStore((s) => s.vehicles)
  const removeVehicle = useHomeStore((s) => s.removeVehicle)
  const setVehicleInsurance = useHomeStore((s) => s.setVehicleInsurance)
  const clearVehicleInsurance = useHomeStore((s) => s.clearVehicleInsurance)
  const globalCoverage = useHomeStore((s) => s.general.pojistne_kryti)

  const [editId, setEditId] = useState<number | null>(null)
  const [deleteId, setDeleteId] = useState<number | null>(null)

  const editing = vehicles.find((v) => v.id === editId)
  const deleting = vehicles.find((v) => v.id === deleteId)
  const globalHavActive = isHavarijniActive(globalCoverage)

  if (vehicles.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-zinc-300 bg-white p-8 text-center text-sm text-zinc-500">
        Zatím žádná vozidla. Přidejte VIN nebo nahrajte dokumenty.
      </div>
    )
  }

  return (
    <>
      <div className="space-y-4">
        {vehicles.map((v) => (
          <VehicleCard
            key={v.id}
            vehicle={v}
            onEditInsurance={() => setEditId(v.id)}
            onDelete={() => setDeleteId(v.id)}
            onVinChanged={onReenqueue}
            globalHavActive={globalHavActive}
          />
        ))}
      </div>

      <CoverageModal
        open={editing !== undefined}
        initial={(editing?.insurance ?? globalCoverage) as CoverageValues}
        onClose={() => setEditId(null)}
        onSave={(c) => {
          if (editId !== null) setVehicleInsurance(editId, c)
          setEditId(null)
        }}
        onReset={editing?.insurance ? () => {
          if (editId !== null) clearVehicleInsurance(editId)
          setEditId(null)
        } : undefined}
      />

      <DeleteVehicleModal
        open={deleting !== undefined}
        vin={deleting?.vin}
        onCancel={() => setDeleteId(null)}
        onConfirm={() => {
          if (deleteId !== null) removeVehicle(deleteId)
          setDeleteId(null)
        }}
      />
    </>
  )
}
